/**
 * utils/residenza.js — chi risiede in Italia, e lo Stato di residenza che
 * non e' arrivato. Una copia sola per le schermate che lo chiedono: il modulo
 * d'accettazione (alla postazione e al tablet), «Modifica dati» e la coda
 * delle accettazioni dal tablet.
 *
 * Fino al 4/10/2026 la regola stava scritta tre volte, uguale, in tre file
 * (ModulisticaWizard, PazienteForm, AccettazioniTablet): tre copie che oggi
 * coincidono sono tre copie che domani divergono in silenzio.
 *
 * Nel database lo stesso campo lo legge paese_da_nome() (la nazione del
 * soggetto di fatturazione, migration 243; il compito della 288). Le due
 * regole non sono confrontate da una prova: un nome che solo una delle due
 * riconosce (per esempio «IT» o «Repubblica Italiana») oggi le divide.
 */

/* Vuoto significa Italia: e' la convenzione della colonna
   pazienti_tab.stato_residenza, dove scrivere «Italia» su ventiseimila righe
   importate avrebbe affermato un dato che nessuno ha verificato. */
export const residenzaInItalia = (stato) =>
    !String(stato ?? '').trim() || /^ital/i.test(String(stato).trim());

/* Lo Stato di residenza e' arrivato con la scheda di partenza? Un oggetto
   senza la chiave non dice «Italia»: dice che il campo non c'era (una rotta
   che non lo porta, un backend tornato indietro). Il 4/10/2026 era la
   sessione della pratica al tablet. */
export const residenzaArrivata = (partenza) =>
    !!partenza && Object.prototype.hasOwnProperty.call(partenza, 'stato_residenza');

/**
 * L'anagrafica da mandare, senza lo Stato di residenza se dalla scheda di
 * partenza non era arrivato e nessuno lo ha scritto.
 *
 * PERCHE'. Per questo campo il server tratta il vuoto come un'informazione
 * («Italia», dal 12/09/2026) e la chiave assente come «non me lo hai detto»
 * (tiene quello che c'e'). Un modulo che si apre senza il valore lo mostra
 * vuoto e lo rimanda vuoto: chi abita all'estero diventava residente in
 * Italia senza che nessuno lo avesse detto. Un valore mancante non diventa il
 * ripiego.
 *
 * Senza scheda di partenza (un paziente nuovo) o col campo arrivato, si manda
 * com'e': li' la casella vuota e' quella che la persona ha visto e lasciato.
 */
export const senzaResidenzaNonArrivata = (anagrafica, partenza) => {
    if (!partenza || residenzaArrivata(partenza)) return anagrafica;
    if (String(anagrafica?.stato_residenza ?? '').trim()) return anagrafica;
    const resto = { ...(anagrafica || {}) };
    delete resto.stato_residenza;
    return resto;
};
